import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronRight } from "@carbon/icons-react";

import Dropdown from "../dropdown/Dropdown";
import ReactPaginate from "react-paginate";
import CustHead from "./CustHead";

import axios from "axios";
import { DecryptData } from "../../../utils/Cipher";
import Constants from "../../../utils/Constants";
import SplashScreen from "../../../components/loader/SplashScreen/SplashScreen";
import { useQuery } from "@tanstack/react-query";
import Filterhead from "./Filterhead";






const BankTransferTab = ({ Apiendpoint, summaryrefetch }) => {
  // This is for tracking dropdown row
  const [expandedRow, setExpandedRow] = useState(null);
  const [page, setPage] = useState(1);
  const [loader, Setloader] = useState(false);
  const [isFilter, SetisFilter] = useState(false);
  const [SearchTerm, setSearchTerm] = useState("");

  // states for search Filter

  const [Startdate, setStartdate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [SearchParam, setSearchParam] = useState("");
  const [paymentType, setPaymentType] = useState("");


  useEffect(() => {
  }, [paymentType]);

  // These headers for csv data it picks data according to the key from object
  const headers = [
    { label: "Order", key: "orderNo" },
    { label: "Full Name", key: "customer[0].fullname" },
    { label: "Contact", key: "customer[0].phone" },
    { label: "Date And Time", key: "createdAt" },
    { label: "Pay Status", key: "paid" },
    { label: "Customer Type", key: "customer[0].type" },
    { label: "Gateway", key: "paymentStatus" },
    { label: "Amount", key: "totalAmount" },
  ];

  const toggleFilter = () => {
    SetisFilter((prev) => !prev); // Toggle the filter state
  };

  //logged in user data
  const userdata = DecryptData();

  //dropdown function
  const toggleDropdown = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };


  const OrdersApi = (page) => {
    return axios({
      method: "get",
      params: {
        search: SearchParam,
        startDate: Startdate,
        endDate: EndDate,
        page: page,
        limit: 100,
        paymentType: paymentType,
        // user: userdata || "", 
      },

      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: Constants.url + `orders/${Apiendpoint}`,
    }).then((res) => {
      setPage(res.data.data.ordersSummary[0].orders.pagination.currentPage);
      return res.data.data;
    });
  };

  const {
    data: Ordersdata1,
    isLoading,
    refetch,
  } = useQuery({
    queryFn: () => OrdersApi(page),
    queryKey: [Apiendpoint, page ],
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });

  const Refresh = () => {
    Setloader(true);
    refetch().then(() => {
      Setloader(false);
    });
  };

  useEffect(() => {
    refetch(); // Refetches data whenever a filter changes
  }, [SearchParam, Startdate, EndDate, paymentType, refetch]);


  return (
    <>
      {!isLoading ? (
        <div className="uk-grid" uk-grid="">
          <div className="uk-width-1-1">
            <CustHead
              RefreshFunc={Refresh}
              headers={headers}
              CsvData={Ordersdata1.ordersSummary[0].orders.items}
              Filename={"Orders.csv"}
              onSearch={setSearchTerm}
              summaryrefetch={summaryrefetch}
              Filtertoggle={toggleFilter}
              Apiendpoint={Apiendpoint}
              setStartdate={setStartdate}
              setEndDate={setEndDate}
              setPaymentType={setPaymentType}
              setSearchParam={setSearchParam}
            />

            <div className="analyticsTableWrp uk-margin-top ">
              {isFilter && (
                <div className="uk-animation-slide-top-medium ">
                  <Filterhead />
                </div>
              )}

              {!loader ? (

                <div className="uk-overflow-auto">
                <table className="uk-table uk-table-striped  "style={{whiteSpace:"nowrap"}}  >
                  <thead className="table-header-shadow">
                    <tr>
                      <th>S.NO</th>
                      <th>Order</th>
                      <th>Cust. Name</th>
                      <th>Contact</th>
                      <th>Dealership</th>
                      <th>Date And Time</th>
                      <th>Month</th>
                      <th className="uk-text-center">Customer Type</th>
                      <th className="uk-text-center">Pay Status</th>
                      <th>Deposit Slip No</th>
                      <th>Second Bank Slip</th>
                      <th>Product</th>
                      <th>Variant</th>
                      <th>Exterior</th>
                      <th>Interior</th>
                      <th>Gateway</th>
                      <th>Amount</th>
                      <th>Delivery Date</th>
                      <th>PBO Issue Date</th>
                      <th>Charger</th>
                      
                    </tr>
                  </thead>

                  <tbody>
                    {Ordersdata1.ordersSummary[0].count > 0 ? (
                      <>
                        {Ordersdata1.ordersSummary[0].orders.items
                          ?.filter((item) => {
                            return SearchTerm.toLowerCase() === ""
                              ? item
                              : item.orderNo
                                  .toLowerCase()
                                  .includes(SearchTerm.toLowerCase());
                          })
                          .map((row, index) => (
                            <React.Fragment key={index}>
                              <tr>
                                {/* this formula should be adjusted according to pagination limit */}
                                <td>{(page - 1) * 100 + (index + 1)}</td>
                                {/* Order No */}
                                <td>{row.orderNo || "-"}</td>
                                {/* Customer NAme  */}
                                <td>
                                  <div className="uk-inline">
                                    <button
                                      onClick={() => toggleDropdown(row.id)}
                                      style={{
                                        border: "1px solid rgb(221 221 221)",
                                        background: "rgb(255 255 255)",
                                        marginRight: "5px",
                                      }}
                                    >
                                      {expandedRow != row.id ? (
                                        <ChevronRight />
                                      ) : (
                                        <ChevronDown />
                                      )}
                                    </button>
                                  </div>
                                  {row.details.customerInfo ? row.details.customerInfo.fullname || "-" : "-"}
                                  </td>

                                {/* Phone */}
                                <td>
                                  {row.customer.length > 0
                                    ? row.details.customerInfo ? row.details.customerInfo.phone || "-" : "-"
                                    : "-"}
                                </td>
                                {/* Dealership */}
                                <td>
                                  {row.customer.length > 0
                                    ? row?.dealer[0]?.name || "-"
                                    : "-"}
                                </td>
                                {/* Date */}
                                <td>
                                  {" "}
                                  {row.createdAt
                                    ? new Date(row.createdAt).toLocaleString(
                                        "en-US",
                                        {
                                          year: "numeric",
                                          month: "numeric",
                                          day: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                          timeZone: "Asia/Karachi",
                                        }
                                      )
                                    : "-"}
                                </td>
                                {/* Month */}
                                <td>
                                  {" "}
                                  {row.createdAt
                                    ? new Date(row.createdAt).toLocaleString(
                                        "en-US",
                                        {
                                          
                                          month: "long",
                                          
                                          
                                          
                                        }
                                      )
                                    : "-"}
                                </td>

                                {/* Customer Type  */}
                                <td className="uk-text-center">
                                  {" "}


                                  {row.details.customerInfo?.type
                                    ? row.details.customerInfo.type
                                    : "-"}{" "}
                                    
                                </td>
                                {/* Pay Status */}
                                <td className="entriesBtn uk-text-center">
                                  <span
                                    style={{
                                      background: row.paid
                                        ? "var(--success)"
                                        : "var(--warn)",
                                    }}
                                  >
                                    {row.paid ? "Paid" : "Partial Paid"}
                                  </span>
                                </td>
                                {/* Deposit Slip */}
                                <td className="uk-text-center">
                                  {row.depositSlipNo || "-"}
                                </td>

                                <td className="uk-text-center">
                                  {row.secondInvoiceNo || "-"}
                                </td>

                                <td>
                                  {row.details.variant.productName || "-"}
                                </td>
                                <td>
                                  {row.details.variant.variantName || "-"}
                                </td>
                                <td>
                                  {row.details.color.exterior
                                    .exteriorColorName || "-"}
                                </td>
                                <td>
                                  {row.details.color.interior
                                    .interiorColorName || "-"}
                                </td>

                                {/* Gateway */}
                                <td className="entriesBtn">
                                  <span style={{ color: "black" }}>
                                    {" "}
                                    {row.paymentStatus === "pending-dealership"
                                      ? "pending-bank"
                                      : row.paymentStatus}
                                  </span>
                                </td>
                                {/* Amount */}
                                <td>
                                  PKR.{" "}
                                  {new Intl.NumberFormat("en-PK", {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }).format(row.totalAmount)}
                                </td>


                                <td className="uk-text-center">
                                  {row.deliveryDate
                                    ? new Date(row.deliveryDate).toLocaleString(
                                        "en-US",
                                        {
                                          year: "numeric",
                                          month: "numeric",
                                          day: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                          timeZone: "Asia/Karachi",
                                        }
                                      )
                                    : "-"}
                                </td>

                                <td>
                                                                
                                  {row.orderPaymentDocuments
                                  .filter(p => p.documentType === 'pbo'  )
                                  .map(p =>
                                    new Date(p.createdAt).toLocaleString(
                                      "en-US",
                                      {
                                        year: "numeric",
                                        month: "numeric",
                                        day: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                        timeZone: "Asia/Karachi",
                                      }
                                    )                                                                    
                                  )                                                                      
                                  }
                                </td>


                                <td className="uk-text-center">
                                {row.charger ? "Yes" : "No"}
                                  {/* {row.charger||"-"} */}
                                </td>
                              </tr>

                              {expandedRow === row.id && (
                                <tr>
                                  <td
                                    className="uk-animation-slide-top-medium"
                                    colSpan="19"
                                  >
                                    <Dropdown
                                      key={row.id}
                                      closeFunc={toggleDropdown}
                                      data={row}
                                      refetch={refetch}
                                      summaryrefetch={summaryrefetch}
                                      invoiceInfo={Ordersdata1.invoiceInfo || 0}
                                    />
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))}
                      </>
                    ) : (
                      <tr className=" uk-width-1-1 uk-text-center">
                        {" "}
                        <td className=" " colSpan={18}>
                          {" "}
                          No Record Found{" "}
                        </td>{" "}
                      </tr>
                    )}
                  </tbody>
                </table>
                </div>


              ) : (
                <SplashScreen />
              )}

              <div className="ordnv uk-card uk-card-default uk-margin-remove-top ">
                <ReactPaginate
                  previousLabel={"←"}
                  nextLabel={"→"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(
                    Ordersdata1.ordersSummary[0].count / 100
                  )}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={(e) => {
                    setPage(e.selected + 1);
                  }}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SplashScreen />
      )}
    </>
  );
};

export default BankTransferTab;
